<template>
  <forward-simulations :is-dashboard="true" />
</template>

<script>
import ForwardSimulations     from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/methodologies/ForwardSimulations'

export default {
  name      : 'RiskDistribution',
  components: {
    ForwardSimulations
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
